import React, { useState, useRef } from "react";

function NewIBMToolForm({ onSave }) {
    // local state
    const [result, setResult] = useState(0);
    const weightRef = useRef(0);
    const heightRef = useRef(0);
    const lossWRef = useRef(0);

    const calIBM = () => {
        try {
            const w = weightRef.current.value;
            const h = heightRef.current.value;
            if (w && h) {
                const m2 = Math.pow(h / 100, 2);
                const r = w / m2;
                setResult(r.toFixed(1));
            }
        } catch (error) {
            console.log("New IBM tool:", error);
        }
    };
    return (
        <form
            onSubmit={(event) => {
                event.preventDefault();
                if (result < 50 && result > 8)
                    onSave({
                        height: parseInt(heightRef.current.value),
                        weight: weightRef.current.value,
                        bmi: result,
                        lossWeight: lossWRef.current.value,
                    });
            }}
        >
            <div className="row">
                <div className="col-4 bg-primary pl-5">
                    <h5>MUST Score</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "25%", backgroundColor: "aliceblue" }}>
                                <strong>Weight (kg)*</strong>
                            </td>
                            <td style={{ width: "25%" }}>
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="weight-id"
                                    name="weight-id"
                                    required
                                    ref={weightRef}
                                    onChange={(ev) => {
                                        if (ev.target.value) calIBM();
                                    }}
                                    min="0"
                                    aria-describedby="weight-id"
                                    placeholder="enter weight"
                                />
                            </td>
                            <td style={{ width: "25%", backgroundColor: "aliceblue" }}>
                                <strong>Height (cm)*</strong>
                            </td>
                            <td style={{ width: "25%" }}>
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="height-id"
                                    name="height-id"
                                    ref={heightRef}
                                    required
                                    min="0"
                                    onChange={(ev) => {
                                        if (ev.target.value) calIBM();
                                    }}
                                    aria-describedby="height-id"
                                    placeholder="enter height"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "25%", backgroundColor: "aliceblue" }}>
                                <strong>Unplanned weight loss in the past 3-6 months</strong>
                            </td>
                            <td colSpan="3">
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="unplanned-id"
                                    min="0"
                                    required
                                    ref={lossWRef}
                                    name="unplanned-id"
                                    aria-describedby="unplanned-id"
                                    placeholder="enter value"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "25%", backgroundColor: "aliceblue" }}>
                                <strong>IBM Score*</strong>
                            </td>
                            <td>
                                {result < 50 && result > 8 && (
                                    <div className="fade-in">
                                        <h4 className="text-success">{result}</h4>
                                    </div>
                                )}
                            </td>
                            <td style={{ width: "25%", backgroundColor: "aliceblue" }}>
                                <strong>Result*</strong>
                            </td>
                            <td>
                                {result < 50 && result > 8 && (
                                    <div className="fade-in">
                                        {result < 18.6 && <h5 className="text-warning">Under weight</h5>}
                                        {result > 18.6 && result < 24.9 && <h5 className="text-success">Normal weight</h5>}
                                        {result > 24.9 && <h5 className="text-danger">Overweight</h5>}
                                    </div>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="text-right fade-in">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                    Save Result <i className="material-icons">arrow_right_alt</i>
                </button>
            </div>
        </form>
    );
}

export default NewIBMToolForm;
